module.exports = __webpack_public_path__ + "img/userCaseNav5.e2435ae5.png";